import gql from "graphql-tag";

export const CREATE_USER = gql`
    mutation CreateUser($email: String!, $password: String!, $accountActivationCallbackPath: String!) {
        createUser (input: {
            email: $email,
            password: $password,
            accountActivationCallbackPath: $accountActivationCallbackPath
        }){
            user{
                email
            }
        }
    }
`;
